import { SortNormalTableIcon } from '@assets/svgs/SortNormalTableIcon'
import { SortAscTableIcon } from '@assets/svgs/SortAscTableIcon'
import { SortDescTableIcon } from '@assets/svgs/SortDescTableIcon'

import type { SortableHeaderProps } from './types'
import type { SortDirection } from '../../types'

import * as S from './styles'
import { Tooltip } from '@components/shared/Tooltip'

export const SortableHeader = ({
  children,
  sortable = false,
  align = 'left',
  currentSortDirection = 'normal',
  isActive = false,
  onSort
}: SortableHeaderProps) => {
  const handleClick = () => {
    if (!sortable || !onSort) return

    const nextDirection: SortDirection =
      !isActive || currentSortDirection === 'normal' ? 'asc' : currentSortDirection === 'asc' ? 'desc' : 'normal'

    onSort(nextDirection)
  }

  const getSortIcon = () => {
    if (!sortable) return null
    if (!isActive)
      return (
        <Tooltip title="Não ordenado" placement="top">
          <SortNormalTableIcon />
        </Tooltip>
      )

    switch (currentSortDirection) {
      case 'asc':
        return (
          <Tooltip title="Ascendente" placement="top">
            <SortAscTableIcon />
          </Tooltip>
        )
      case 'desc':
        return (
          <Tooltip title="Descendente" placement="top">
            <SortDescTableIcon />
          </Tooltip>
        )
      default:
        return (
          <Tooltip title="Não ordenado" placement="top">
            <SortNormalTableIcon />
          </Tooltip>
        )
    }
  }

  return (
    <S.Container sortable={sortable} align={align} onClick={handleClick}>
      {children}
      <S.SortIcon>{getSortIcon()}</S.SortIcon>
    </S.Container>
  )
}
